/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Kiotviet_Line_MetaInputs */

const vi_kiotviet_line_meta = /** @type {(inputs: Kiotviet_Line_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã KiotViet: ${i?.code}`)
};

/**

* @param {Kiotviet_Line_MetaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_line_meta = /** @type {((inputs: Kiotviet_Line_MetaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Line_MetaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_line_meta(inputs)
});